export const SET_CENTROSRX = "SET_CENTROSRX";
export const UPDATE_CENTROSRX_IN_ARRAY = "UPDATE_CENTROSRX_IN_ARRAY";
